import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { RAFormModule } from '../../../ra-form/ra-form.module';
import { change_passwordComponent } from './change_password.component';
import { HttpLoaderFactory } from 'src/app/http-loader-factory';
@NgModule({
imports: [
CommonModule,
RAFormModule,
FormsModule,
HttpClientModule,
TranslateModule.forChild({
loader: {
provide: TranslateLoader,
useFactory: HttpLoaderFactory, // Moved to Seperate File By Mirsha
deps: [HttpClient]
}
}),
],
declarations: [
change_passwordComponent,
],
exports:[
change_passwordComponent,
],
})
export class change_passwordModule { }
